import React from 'react';
import './Activities.css';
import './teamAct.css';
import { Form, Input, Select, Button, Modal, Radio, message, Carousel, DatePicker, Cascader } from 'antd';
import { FormattedMessage, injectIntl } from 'react-intl';
import { GetLMSMainIndustry, getTopBannerPhoto, TeamSumbit, GetTeamAppointmentCities, GetCascade} from "../../api/api";
import dayjs from 'dayjs'
import moment from "moment"
import { connect } from "react-redux"
import actions from "../../store/actions"
import Calendar from '../../component/Calendar'
let tddzimg1 = require("../../static/images/tddz.png");
let tddzimg2 = require("../../static/images/tddz_en.png");
let groupimg = require("../../static/images/group.png");
let banner1 = require("../../static/images/teamBanner1.jpg");
let banner2 = require("../../static/images/teamBanner2.jpg");
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;
let address = "https://www.lenovofuturecenter.com/sit/";
if (window.location.hostname != "localhost") {
    address = "https://www.lenovofuturecenter.com/";
}
class teamAct extends React.Component {
    state = {
        bannerPhoto: [banner1, banner2],
        data: [],
        DataResult: [],
        time: "",
        Industry: [],
        historyDate: {},
        VisitPurposeObj: {},
        showCalendar: false,
        dateFormat: this.props.location.name,
        phonePattern: /^\d+$/,
        purpose: "",
        cities: [],
        viesiteTime: '',
        visitGroup: '',
        viesitePicker: '',
        cityOptions: [],
        visitRegion: [],
        GetVisitTimes: [
          {tiem: '9:00-10:00',id:1},
          {tiem: '10:00-11:00',id:2},
          {tiem: '11:00-12:00',id:3},
          {tiem: '14:00-15:00',id:4},
          {tiem: '15:00-16:00',id:5},
          {tiem: '16:00-17:00',id:6},
          {tiem: '17:00-18:00',id:7},
        ],
        getPeoplegroup: [
          {
            value: '政府',
            code: '政府',
            text: '政府'
          },
          {
            value: '企业',
            code: '企业',
            text: '企业'
          },
          {
            value: '中小学',
            code: '中小学',
            text: '中小学'
          },
          {
            value: '高校',
            code: '高校',
            text: '高校'
          },
          {
            value: '其它',
            code: '其它',
            text: '其它'
          },
        ]
    };

    /*下一步按钮*/
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
              delete values.picker
              delete values.citydata
              delete values.time
            var IndustryObj = this.state.Industry.find((x) => { return x.Value === values.Industry; })
            if (!err) {
                let Purpose = "";
                switch (this.state.purpose) {
                    case "1":
                        Purpose = "预约参观";
                        break;
                    case "2":
                        Purpose = "活动咨询";
                        break;
                    case "3":
                        Purpose = "媒体合作";
                        break;
                    case "4":
                        Purpose = values.otherPurpose;
                        break;

                    default:
                        break;
                }

                let visitDate = this.state.viesitePicker + ' ' + this.state.viesiteTime
                // console.log(this.state.visitRegion.join(','),'this.state.visitRegionthis.state.visitRegion')
                // console.log(visitRegion0,visitRegion1,visitRegion2)
                let visitRegion = this.state.visitRegion.map(item=>{
                  return JSON.stringify(item)
                }).join(',')
                // console.log(data)
                // this.state.visitRegion.forEach(item=>{
                //   console.log(item,'cc')
                //   visitRegion = item
                // })
                // for(key)
                // let visitRegion = ''
                // visitRegion = this.state.visitRegion[0]+','+this.state.visitRegion[1]+','+this.state.visitRegion[2]
                // console.log(visitRegion)
                // console.log(JSON.parse(this.state.visitRegion[0]),JSON,)
                // let visitRegion = this.state.visitRegion[0]+','+this.state.visitRegion[1]+','+this.state.visitRegion[2]
                // let visitRegion = {}
                // for()
                // visitDate,
                let info = {
                    ...values,
                    purpose: Purpose,
                    visitDate,
                    visitRegion: visitRegion
                }
                console.log(info,info.visitRegion)
                


                  
                TeamSumbit(info).then((res) => {
                    console.log(res,'res')
                    if (res.data) {
                        this.props.history.push('/Successful');
                    }
                }).then(() => {

                })
            }
        });
    };
    /*获取数据*/
    handleBack11 = (value) => {
        //     let VisitPurposeObj = this.state.VisitPurposeObj;
        //     this.state.data.forEach((item) => {
        //         console.log(item.Value);
        //         if (item.Value === value.item.props.eventKey) {
        //             VisitPurposeObj.Value = item.Value;
        //             VisitPurposeObj.ValueNameEN = item.ValueNameEN;
        //             VisitPurposeObj.ValueNameCN = item.ValueNameCN;
        //         }
        //   this.setState({
        //             VisitPurpose: VisitPurposeObj
        //         })
        //     })
    };
    componentWillMount() {
        /*临时存储数据*/
        let history = this.props.value;
        let cleanValue = this.props.cleanValue;
        var dateFormat = this.state.dateFormat;
        // if (!dateFormat) {
        //     this.setState({
        //         showCalendar: true
        //     });
        // }
        if (cleanValue.cleanVis === true) {
            this.setState({
                historyDate: {}
            })
        } else {
            if (history !== undefined) {
                this.setState({
                    historyDate: {
                        VisitUnit: history.VisitUnit,
                        VisitDate: history.VisitDate,
                        VisitTime: history.VisitTime,
                        note: history.note,
                        Industry: history.Industry,
                        language: history.language,
                        GroupInfo: history.GroupInfo,
                    }
                })
            }
        }


        /*来访目的*/
        // GetGroupInfo().then((response) => {
        //     let data = response.DataResult;
        //     this.setState({
        //         data: data
        //     });
        // }).catch((error) => {
        //     console.log(error);
        // });


    }

       /* 获取来访日期 */
    onChangePicker = (date,dateString) => {
      this.setState({viesitePicker: dateString})
      // console.log(urbanCascade,'urbanCascadeurbanCascadeurbanCascade')
      
      // console.log(dateString,'来访时间')
    }
  
      /* 获取来访时间 */
    onChangeTime = (data) => {
      this.setState({
        viesiteTime: data
      })
      // console.log(data,'来访时间')
    } 

    getGroup = (data) => {
      this.setState({
        visitGroup: data
      })
    }
    /* 城市级联 */
    onVisitRegion = (value,selectedOptions) => {
      console.log(value,selectedOptions[0].value,'data')
      let data = selectedOptions.map(item=>{
        // return {item.text}
        console.log(item.text,item.value)
        let value = item.value
        let text = item.text
        return {text,value}
      })
      this.setState({visitRegion: data})
    }
    hideCalendar() {
        this.setState({
            showCalendar: false
        });
    }
    showCalendar() {
        this.setState({
            showCalendar: true
        });
    }
    clickDay(date) {
        if (date) {
            this.setState({
                dateFormat: date
            }, () => {
                this.hideCalendar();

            });
            //
            // GetVisitTime({
            //     applyDate: date
            // }).then((response) => {
            //     let data = response.DataResult;
            //     if (data) {
            //         this.setState({
            //             DataResult: data
            //         });
            //     }
            // }).catch((error) => {
            //     console.log(error);
            // });
        }
    }
    componentDidMount() {
        // banner
        // getTopBannerPhoto("TeamAppointment").then((res) => {
        //     if (res.ResultType == 0) {
        //         let bannerPhoto = res.DataResult;
        //         this.setState({ bannerPhoto })
        //     }
        // }).catch((error) => {
        //     console.log(error);
        // });
        /*来访时间*/
        // GetVisitTime({
        //     applyDate: this.props.location.name || this.state.time
        // }).then((response) => {
        //     if (response.DataResult) {
        //         let data = response.DataResult;
        //         this.setState({
        //             DataResult: data
        //         });
        //     }
        // }).catch((error) => {
        //     console.log(error);
        // });
        /*职业*/
        GetLMSMainIndustry().then((response) => {
            let data = response.DataResult;
            this.setState({
                Industry: data
            });

        }).catch((error) => {
            console.log(error);

        });
        GetTeamAppointmentCities().then(response => {
            let data = response.DataResult;
            this.setState({
                cities: data
            });
        }).catch(error => {

        });

        /* 获取级联城市列表 */ 
        GetCascade().then(res => {
          // console.log(res,'resres')
          let data = res.map(item=>{
            item.label = item.text
            // console.log(item.children)
            item.children ? item.children.forEach(it=>{
              it.label = it.text
              // it.children.forEach(i=>{
              //   i.label = i.text
              // })
              it.children ? it.children.forEach(i=>{
                i.label = i.text
              }) : it.children
            }): item.children
            return item
          })
          this.setState({
            cityOptions: data
          })
        }).catch(e=>{})

    }
    purposeChange(e) {
        let purpose = e.target.value;
        this.setState({ purpose });
    }

     /*来访时间*/ 
     GetVisitTime(current) {
      return (current > moment().add(35,'day') || current < moment().add(5,'day'))
    }

    openBanner(type, url) {
        if (url) {
            if (type != "Other" && type != "Internal") {
                window.open(url)
            }
        }
    }
    formatMessage(id) {
        console.log(this);
        return this.props.intl.formatMessage({ id: id });

    }
    render() {
        const { getFieldDecorator } = this.props.form;
        const { bannerPhoto, historyDate, purpose } = this.state;
        const dateFormat = this.state.dateFormat;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 10 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 14 },
            },
        };
        return (<div className="insideDiv teamActDiv">
            <Carousel autoplay>
                {bannerPhoto.map((d, i) => {
                    return <div key={i}>
                        <img src={d} />
                    </div>
                })}
            </Carousel>
            <div className="center">
                <div className="tddz">
                    <img src={this.props.local === 'zh' ? tddzimg1 : tddzimg2} />
                    <div><FormattedMessage
                        id="intl-Activities-teamTitle"
                    /></div>
                </div>
                <Form className="teamFrom" onSubmit={this.handleSubmit} style={{ margin: 0 }}>
                    <div className="ftitle"><img src={groupimg} /><span><FormattedMessage
                        id="intl-Activities-CustomerInformation"
                    /></span></div>
                    <Modal
                        className='Group_calendar'
                        title={this.props.local === 'zh' ? "日历" : "Calendar"}
                        visible={this.state.showCalendar}

                        onCancel={this.hideCalendar.bind(this)}
                        okText=""
                        cancelText=""
                        footer="."
                        width={600}

                    >
                        <Calendar  local={this.props.local} history={this.props.history} clickDay={this.clickDay.bind(this)} />


                    </Modal>
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-City"
                        />}
                        help=""
                    >
                        {getFieldDecorator('regionId', {
                            initialValue: historyDate && historyDate.regionId,
                            rules: [{
                                required: true, message: '',
                            }],
                        })(<Select
                            showSearch
                            style={{ width: 300 }}
                        >
                            {
                                this.state.cities.map(city => (
                                    <Option key={city.code} disabled={!city.enabled} value={city.code}>
                                        {this.props.local === "en" ? city.enName : city.name}
                                    </Option>
                                ))
                            }
                        </Select>,
                        )}
                    </FormItem>
                    {/*单位*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-VisitTheUnit"
                        />}
                        help=""
                    >
                        {getFieldDecorator('teamName', {
                            initialValue: historyDate && historyDate.teamName,
                            rules: [{
                                required: true, message: '',

                            }, {
                                validator: this.compareToFirstPassword,
                            }],
                        })(
                            <Input style={{ width: "300px" }} />
                        )}
                    </FormItem>
                    {/*来访语言*/}
                    {/* <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-language"
                        />}
                        help=""
                    >
                        {getFieldDecorator('language', {
                            initialValue: historyDate && historyDate.language,
                            rules: [{
                                required: true, message: 'Please confirm your password!',
                            }],
                        })(<Select
                            showSearch
                            style={{ width: 300 }}
                        >
                            <Option value={this.props.local === "en" ? "Chinese" : "中文"}>
                                <FormattedMessage
                                    id="intl-Activities-language1"
                                />
                            </Option>
                            <Option value={this.props.local === "en" ? "English" : "英语"}>
                                <FormattedMessage
                                    id="intl-Activities-language4"
                                /></Option>
                        </Select>,
                        )}
                    </FormItem> */}
                    {/*来访行业*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-Subordinate"
                        />}
                        help=""
                    >
                        {getFieldDecorator('industry', {
                            initialValue: historyDate && historyDate.industry,
                            rules: [{
                                required: true, message: 'Please confirm your password!',
                            }],
                        })(
                            <Select
                                showSearch
                                style={{ width: 300 }}
                            >
                                {this.state.Industry.map((item, i) => {
                                    return <Option key={i}
                                        value={item.value}>{this.props.local === "en" ? item.valueNameEN : item.valueNameCN}</Option>
                                })}
                            </Select>,
                        )}
                    </FormItem>

                    {/* 来访地区 */}

                    <FormItem
                      {...formItemLayout}
                      label={<FormattedMessage
                          id="intl-Activities-CityCascade"
                      />}
                      help=""
                      required= { true }
                    >
                      {getFieldDecorator('citydata', {
                          initialValue: historyDate && historyDate.citydata,
                          rules: [{
                              required: true, message: 'Please confirm your password!',
                          }],
                      })(
                          <Cascader
                            style={{ width: 300 }}
                            placeholder=""
                            options= { this.state.cityOptions }
                            onChange= { this.onVisitRegion }
                          ></Cascader>
                      )}
                    </FormItem>

                    {/* 期望到访时间 */}
                    <FormItem
                      {...formItemLayout}
                      label={<FormattedMessage
                          id="intl-Activities-VisitTime"
                      />}
                      help=""
                      required={true}
                    > 
                    {getFieldDecorator('picker', {
                        rules: [{
                            required: true, message: 'Please confirm your password!',
                        }],
                    })(
                        <DatePicker style={{ width: 135 }} 
                          format="YYYY-MM-DD" 
                          onChange={this.onChangePicker} 
                          disabledDate={this.GetVisitTime}
                          placeholder=""
                        />
                    )} -  {getFieldDecorator('time', {
                            initialValue: historyDate && historyDate.citydata,
                            rules: [{
                              required: true, message: 'Please confirm your password!',
                            }],
                          })(
                            <Select
                              showSearch
                              style={{ width: 150 }}
                              onChange={this.onChangeTime}
                            >
                              {this.state.GetVisitTimes.map((item)=>{
                                return <Option key={item.id} value={item.tiem}>{item.tiem}</Option>
                              })}
                            </Select>
                            )}
                        {/* <DatePicker style={{ width: 130 }} 
                          format="YYYY-MM-DD" 
                          onChange={this.onChangePicker} 
                          disabledDate={this.GetVisitTime}
                        /> - <Select
                          showSearch
                          style={{ width: 150 }}
                          onChange={this.onChangeTime}
                        >
                          {this.state.GetVisitTimes.map((item)=>{
                            return <Option key={item.id} value={item.tiem}>{item.tiem}</Option>
                          })}
                        </Select> */}
                    {/* defaultValue={moment().add(6,'day')} */}
                     
                    
                    </FormItem>

                    {/*日期*/}
                    {/* <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-Dateofvisit"
                        />}
                        help="">
                        {getFieldDecorator('VisitDate', {
                            initialValue: dateFormat || historyDate.VisitDate,
                            rules: [{
                                required: true,
                            }],
                        })(
                            <Input style={{ width: "300px" }} onClick={this.showCalendar.bind(this)} />
                        )}

                    </FormItem> */}
                    {/* 期望参访人数 */}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-VisitBumber"
                        />}
                        help=""
                    >
                        {getFieldDecorator('number', {
                            initialValue: historyDate && historyDate.number,
                            rules: [{
                                required: true, pattern: /^[0-9]*$/
                            }],
                        })(<Input style={{ width: "300px" }} maxLength={5}/>
                        )}
                    </FormItem>

                    {/* 参访人员群体 */}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-VisitGroup"
                        />}
                        help=""
                    >
                        {getFieldDecorator('visitGroup', {
                            initialValue: historyDate && historyDate.visitGroup,
                            rules: [{
                                required: true,
                            }],
                        })( 
                        <Select
                          showSearch
                          style={{ width: 150 }}
                          onChange={this.getGroup}
                        >
                          {this.state.getPeoplegroup.map((item)=>{
                            return <Option key={item.id} value={item.value}>{item.value}</Option>
                          })}
                        </Select>
                        )}
                    </FormItem>
                    {/*团队简介*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-GroupInfo"
                        />}
                        help=""
                    >
                        {getFieldDecorator('teamIntro', {
                            initialValue: historyDate && historyDate.teamIntro,
                            rules: [{
                                required: true,
                            }],
                        })(<Input style={{ width: "300px" }} />
                        )}
                    </FormItem>

                    {/*合作需求*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-purpose"
                        />}
                        help=""
                    >
                        {getFieldDecorator('purpose', {
                            initialValue: purpose,
                            rules: [{
                                required: true,
                            }],
                        })(
                            <RadioGroup onChange={(e) => { this.purposeChange(e) }}>
                                <Radio value="1">
                                    <FormattedMessage
                                        id="intl-Activities-yycg"
                                    /></Radio>
                                <Radio value="2">
                                    <FormattedMessage
                                        id="intl-Activities-hdzx"
                                    /></Radio>
                                <Radio value="3">
                                    <FormattedMessage
                                        id="intl-Activities-mthz"
                                    /></Radio>
                                <Radio value="4">
                                    <FormattedMessage
                                        id="intl-Activities-qt"
                                    /></Radio>
                            </RadioGroup>
                        )}
                    </FormItem>

                    {/*备注*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-Note"
                        />}
                        help=""
                    >
                        {getFieldDecorator('note', {
                            initialValue: historyDate && historyDate.note,
                            rules: [{
                                required: false,
                            }],
                        })(
                            <textarea rows="4" cols="50"
                                style={{ width: "300px", height: "110px", border: "1px solid #ccc", textIndent: "12px", letterSpacing: "2px" }} />
                        )}
                    </FormItem>
                    {this.state.purpose == "4" ? <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-otherPurpose"
                        />}
                        help=""
                    >
                        {getFieldDecorator('otherPurpose', {
                            initialValue: historyDate && historyDate.otherPurpose,
                            rules: [{
                                required: this.state.purpose == "4" ? true : false,
                            }],
                        })(
                            <textarea rows="4" cols="50" placeholder={this.formatMessage('intl-Activities-demandtxt')} style={{ width: "300px", height: "110px", border: "1px solid #ccc", textIndent: "12px", letterSpacing: "2px" }} />
                        )}
                    </FormItem> : null}
                    <div className="line"></div>
                    <div className="ftitle"><img src={groupimg} /><span><FormattedMessage
                        id="intl-Activities3-Information"
                    /></span></div>
                    {/*姓名*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities3-name"
                        />}
                        help=""
                    >
                        {getFieldDecorator('userName', {
                            initialValue: historyDate && historyDate.userName,
                            rules: [{
                                required: true,
                            }],
                        })(<Input style={{ width: "300px" }} />
                        )}
                    </FormItem>
                    {/*职务*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities-Title"
                        />}
                        help=""
                    >
                        {getFieldDecorator('duties', {
                            initialValue: historyDate && historyDate.duties,
                            rules: [{
                                required: true,
                            }],
                        })(<Input style={{ width: "300px" }} />
                        )}
                    </FormItem>
                    {/*手机号*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities3-phone"
                        />}
                        help=""
                    >
                        {getFieldDecorator('mobilePhone', {
                            initialValue: historyDate && historyDate.mobilePhone,
                            rules: [{ pattern: this.state.phonePattern, required: true, message: 'Please input your phone number!' }],
                        })(<Input style={{ width: "300px" }} />
                        )}
                    </FormItem>
                    {/*邮箱*/}
                    <FormItem
                        {...formItemLayout}
                        label={<FormattedMessage
                            id="intl-Activities3-E-mail"
                        />}
                        help=""
                    >
                        {getFieldDecorator('email', {
                            initialValue: historyDate && historyDate.email,
                            rules: [{
                                type: 'email', message: 'The input is not valid E-mail!',
                            }, {
                                required: true, message: 'Please input your E-mail!',
                            }],
                        })(<Input style={{ width: "300px" }} />
                        )}
                    </FormItem>
                    <div className="submitDiv" >
                        <Button type="primary" htmlType="submit" className="tjxxBtn">
                            <FormattedMessage
                                id="intl-Activities-tjxx"
                            />
                        </Button>
                    </div>
                </Form>
            </div>
        </div>)
    }
}



export default connect(state => ({ ...state, ...state.Language, ...state.Home }), { ...actions, ...actions.Language, ...actions.Home })(Form.create()(injectIntl(teamAct)))









// WEBPACK FOOTER //
// ./src/containers/Activities/teamAct.js